import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export function UserMenu() {
  const { user, signOut, isSigningOut } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  if (!user) return null;

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 rounded-full bg-white p-1 shadow-md transition-shadow hover:shadow-lg"
      >
        {user.image ? (
          <img
            src={user.image}
            alt={user.name || "User"}
            className="h-8 w-8 rounded-full"
          />
        ) : (
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-600">
            {user.name?.[0] || user.email[0].toUpperCase()}
          </div>
        )}
        <span className="hidden pr-2 text-sm font-medium text-gray-700 md:inline">
          {user.name || user.email}
        </span>
      </button>

      {isOpen && (
        <div className="absolute end-0 top-12 z-50 w-48 rounded-lg bg-white py-2 shadow-lg">
          <div className="border-b px-4 py-2">
            <p className="text-sm font-medium text-gray-900">
              {user.name || "User"}
            </p>
            <p className="text-xs text-gray-500">{user.email}</p>
          </div>

          <Link
            to="/dashboard"
            onClick={() => setIsOpen(false)}
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            Dashboard
          </Link>

          <Link
            to="/dashboard/projects"
            onClick={() => setIsOpen(false)}
            className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            My Projects
          </Link>

          <hr className="my-1" />

          <button
            onClick={() => {
              setIsOpen(false);
              signOut();
            }}
            disabled={isSigningOut}
            className="block w-full px-4 py-2 text-start text-sm text-red-600 hover:bg-red-50 disabled:opacity-50"
          >
            {isSigningOut ? "Signing out..." : "Sign out"}
          </button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;
